import { Menu } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { useAppSettings } from "@/lib/settings";

export function AppHeader({ showMenu = true }: { showMenu?: boolean }) {
  const { data } = useAppSettings();
  const branding = data?.branding;

  return (
    <header className="gradient-header text-primary-foreground">
      <div className="grid grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-3 px-4 py-4">
        {showMenu ? (
          <Link to="/profile" aria-label="Open profile menu" className="rounded-lg p-1.5 hover:bg-white/10">
            <Menu className="h-5 w-5" aria-hidden="true" />
          </Link>
        ) : <span />}
        <div className="flex min-w-0 items-center justify-center gap-2">
          {branding?.logo_url ? (
            <img src={branding.logo_url} alt="" className="h-7 w-7 shrink-0 rounded-full object-cover" />
          ) : null}
          <h1 className="truncate text-base font-black uppercase tracking-wide">
            {branding?.app_name ?? "Brothers Club"}
            <span className="sr-only"> — Play. Win. Repeat.</span>
          </h1>
        </div>
        <span />
      </div>
    </header>
  );
}
